<template>
  <div class="content-section" id="mypage-password-template">
    <div class="table-wrap mt-0">
      <table class="table-body-only">
        <caption class="ir-text">비밀번호 변경 표</caption>
        <colgroup class="pc-cell">
          <col style="width: 160px" />
          <col />
        </colgroup>
        <colgroup class="mo-cell">
          <col style="width: 88px" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row"><label for="currentpassword">현재 비밀번호</label></th>
            <td>
              <div class="input-group">
                <div class="input-area wid400">
                  <input type="password" v-model="currentPassword" id="currentpassword" placeholder="비밀번호 입력" title="비밀번호 입력">
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row"><label for="password">변경 비밀번호</label></th>
            <td>
              <div class="input-group">
                <div class="input-area wid400">
                  <input type="password" id='password' v-model="password" placeholder="비밀번호 입력" title="비밀번호 입력">
                </div>
              </div>
              <div class="note-text">
                * 비밀번호는 숫자, 영문, 특수문자 포함 9자 이상이어야 합니다.
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">비밀번호 재입력</th>
            <td>
              <div class="input-group">
                <div class="input-area wid400">
                  <input type="password" v-model="passwordConfirm" placeholder="비밀번호 입력" title=" 비밀번호 재입력">
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-area flex-end gap10 mo-button-full mt-32">
      <a href="javascript:history.back();" class="btn btn-secondary btn-md">이전으로</a>
      <a href="#" class="btn btn-primary  btn-md" @click="changePassword" title="비밀번호 변경">비밀번호 변경</a>
    </div>
  </div>
</template>
<script>
  import Axios from 'axios';

  export default {
    name: 'mypage-password',
    data() {
      return {
        currentPassword: '',
        password: '',
        passwordConfirm: '',
      };
    },
    methods: {
      changePassword() {
        const pwdReg = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^*()\-_=+\\|[\]{};:'",.<>/?~`&]).{9,50}$/i;
        if (!this.currentPassword) {
          alert('현재 비밀번호를 입력해 주세요.');
        } else if (!this.password) {
          alert('비밀번호를 입력해 주세요.');
        } else if (!this.passwordConfirm) {
          alert('비밀번호를 재입력해 주세요.');
        } else if (this.currentPassword === this.password) {
          alert('이전 비밀번호와 동일합니다.');
        } else if (this.password !== this.passwordConfirm) {
          alert('비밀번호가 서로 일치하지 않습니다.');
        } else if (!pwdReg.test(this.password)) {
          alert('비밀번호는 숫자, 영문, 특수문자 포함 9자 이상이어야 합니다.');
          $('#password').focus();
        } else {
          const Params = {
            currentPassword: this.currentPassword,
            newPassword: this.password,
          };
          Axios.put('/api/members/change-password', Params).then((res) => {
            alert('비밀번호가 변경되었습니다. 내 정보 페이지로 돌아갑니다.');
            location.href = (res.data.compYn === 'Y') ? '/mypage-info-com.do' : '/mypage-info.do';
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
    },
  };

</script>


// WEBPACK FOOTER //
// MypagePassword.vue?ddbb8088